<template>
    <div id="home">
        <header>
            <section>
                <label for="search">
                    <input :class="{typed: searchInput.length > 0}" autocomplete='off' name="search" id="search" type="text" placeholder="Busque por data, número de ofício, título do documento" v-model="searchInput" @keyup.enter="$router.push({name: 'admin.results',  params: { search: searchInput }})">
                    <svg v-if="searchInput.length == 0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" @click="$router.push('/admin/results')">
                        <path d="M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg v-else @click="searchInput = ''" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M4 4L16 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M16 4L4 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span class="indicative" :class="{visible: searchInput.length > 0}">
                      Aperte ENTER para buscar
                    </span>
                </label>
            </section>
            <section>
                <div class="infos">
                    <h1>Olá, <strong>{{ user.name }}</strong></h1>
                    <!-- <h2>Último acesso em 77/77/77 as 77:77</h2> -->
                </div>
                <button @click="isNotificationsModalOpen = true; viewNotification(true)">
                    <figure>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5206 3.41016C9.21058 3.41016 6.52058 6.10016 6.52058 9.41016V12.3002C6.52058 12.9102 6.26058 13.8402 5.95058 14.3602L4.80058 16.2702C4.09058 17.4502 4.58058 18.7602 5.88058 19.2002C10.1906 20.6402 14.8406 20.6402 19.1506 19.2002C20.3606 18.8002 20.8906 17.3702 20.2306 16.2702L19.0806 14.3602C18.7806 13.8402 18.5206 12.9102 18.5206 12.3002V9.41016C18.5206 6.11016 15.8206 3.41016 12.5206 3.41016Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                            <path d="M14.3699 3.69994C14.0599 3.60994 13.7399 3.53994 13.4099 3.49994C12.4499 3.37994 11.5299 3.44994 10.6699 3.69994C10.9599 2.95994 11.6799 2.43994 12.5199 2.43994C13.3599 2.43994 14.0799 2.95994 14.3699 3.69994Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.5195 19.5601C15.5195 21.2101 14.1695 22.5601 12.5195 22.5601C11.6995 22.5601 10.9395 22.2201 10.3995 21.6801C9.85953 21.1401 9.51953 20.3801 9.51953 19.5601" stroke-width="1.5" stroke-miterlimit="10"/>
                            <circle v-if="newNotification" cx="20" cy="5" r="5" fill="#A30711" stroke='none'/>
                        </svg>
                    </figure>
                </button>
              <div @click="$router.push('/admin/profile')" class="profile" role="img" aria-label="Foto de perfil do usuário">
                  <img v-if="user.image" :src="storageUrl + user.image" alt="Foto de perfil do usuário">
                  <img v-else src="../../../assets/images/no-photo.png" alt="Foto de perfil não disponível">
              </div>
            </section>
        </header>
        <div class="alert" :class="alertRemainingDays?.color" v-if="alert && alertRemainingDays && isAlertVisible">
            <figure>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M28 8.66651C28 11.2398 25.9067 13.3332 23.3333 13.3332C20.76 13.3332 18.6667 11.2398 18.6667 8.66651C18.6667 6.09318 20.76 3.99984 23.3333 3.99984C25.9067 3.99984 28 6.09318 28 8.66651ZM25.3333 15.7198C24.6667 15.8932 24 15.9998 23.3333 15.9998C21.3895 15.9963 19.5263 15.2226 18.1518 13.8481C16.7773 12.4736 16.0035 10.6103 16 8.66651C16 6.70651 16.7733 4.93318 18 3.61318C17.758 3.31657 17.4529 3.07767 17.1069 2.9139C16.761 2.75013 16.3828 2.66562 16 2.66651C14.5333 2.66651 13.3333 3.86651 13.3333 5.33318V5.71984C9.37333 6.89318 6.66667 10.5332 6.66667 14.6665V22.6665L4 25.3332V26.6665H28V25.3332L25.3333 22.6665V15.7198ZM16 30.6665C17.48 30.6665 18.6667 29.4798 18.6667 27.9998H13.3333C13.3333 28.7071 13.6143 29.3854 14.1144 29.8855C14.6145 30.3856 15.2928 30.6665 16 30.6665Z"/>
                </svg>
            </figure>
            <div class="days">
                <span>Faltam</span>
                <span>dias</span>
                <h1>{{ alertRemainingDays.value }}</h1>
            </div>
            <div class="infos">
                <h1>{{ alert.title }}</h1>
                <h2>{{ alert.description }}</h2>
            </div>
            <button @click="isAlertVisible = false">
                <figure>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </figure>
            </button>
        </div>
        <div class="note-alert" :class="noteAlertRemainingDays?.color" v-if="noteAlertNote && noteAlertRemainingDays && isNoteAlertVisible">
            <figure>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 13H16M8 17H13" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </figure>
            <div class="days">
                <span>{{ noteAlertRemainingDays.isToday ? 'Hoje' : 'Faltam' }}</span>
                <span>{{ noteAlertRemainingDays.monthLabel }}</span>
                <h1>{{ noteAlertRemainingDays.isToday ? noteAlertRemainingDays.dayOfMonth : noteAlertRemainingDays.days }}</h1>
            </div>
            <div class="infos">
                <h1>{{ noteAlertNote.title }}</h1>
                <h2 v-if="noteAlertNote.description">{{ stripHtml(noteAlertNote.description) }}</h2>
            </div>
            <button class="cta" @click="$router.push({ name: 'admin.notes.index' })">VER NOTA ></button>
            <button class="close" @click="isNoteAlertVisible = false">
                <figure>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </figure>
            </button>
        </div>
        <div class="updates">
            <section>
                <h1>Suas atualizações</h1>
                <div class="itens">
                    <RouterLink :to="{ name: 'admin.documents.index', query: { status: stat.status } }" class="item" v-for="stat in documentStats">
                        <h1>{{ documentStatusTranslations[stat.status] }}</h1>
                        <p>{{ stat.count }}</p>
                        <h2>{{ documentStatusDescriptions[stat.status] }}</h2>
                    </RouterLink>
                    <div class="item skeleton" v-if="!documentStats">
                        <h1>Enviados</h1>
                        <p>•••</p>
                        <h2>Todos que foram enviados.</h2>
                    </div>
                    <div class="item skeleton" v-if="!documentStats">
                        <h1>Pendentes</h1>
                        <p>•••</p>
                        <h2>Todos que não foram vistos.</h2>
                    </div>
                    <div class="item skeleton" v-if="!documentStats">
                        <h1>Tramitando</h1>
                        <p>•••</p>
                        <h2>Enviados, mas nem todos foram vistos.</h2>
                    </div>
                    <div class="item skeleton" v-if="!documentStats">
                        <h1>Prorrogados</h1>
                        <p>•••</p>
                        <h2>Todos que tiveram datas modificadas.</h2>
                    </div>
                    <div class="item skeleton" v-if="!documentStats">
                        <h1>Em atraso</h1>
                        <p>•••</p>
                        <h2>Todos que não foram vistos até a data limite.</h2>
                    </div>
                    <div class="item skeleton" v-if="!documentStats">
                        <h1>Finalizados</h1>
                        <p>•••</p>
                        <h2>Todos que foram vistos e concluídos.</h2>
                    </div>
                </div>
            </section>
            <!-- CLASSE 'noitens' PARA QUANDO NAO TIVER ITENS -->
            <section class="">
                <h1>ÚLTIMOS QUE RECEBEU</h1>
                <div class="list">
                    <div class="itens" v-if="recentDocuments && recentDocuments.length > 0">
                        <div @click="$router.push({ name: 'admin.documents.show', params: { id: document.id } })" v-for="document in recentDocuments" class="item">
                            <div class="name">
                                <h1>{{ document.responsibles[0].name.split(' ').map(word => word.charAt(0).toUpperCase()).join('') }}</h1>
                            </div>
                            <div class="infos">
                                <h2>Ofício <strong>N° {{ document.number }}</strong></h2>
                                <h1>{{ document.title }}</h1>
                                <h2 v-if="document.organizations.length">{{ document.organizations[0].acronym }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="itens empty" v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                        <path d="M21.0003 51.3333H35.0003C46.667 51.3333 51.3337 46.6666 51.3337 35V21C51.3337 9.33329 46.667 4.66663 35.0003 4.66663H21.0003C9.33366 4.66663 4.66699 9.33329 4.66699 21V35C4.66699 46.6666 9.33366 51.3333 21.0003 51.3333Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M42 18.0833V33.8333C42 31.2666 39.9 29.1666 37.3333 29.1666H18.6667C16.1 29.1666 14 31.2666 14 33.8333V18.0833C14 15.5166 16.1 13.4166 18.6667 13.4166H37.3333C39.9 13.4166 42 15.5166 42 18.0833Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M44.3333 36.75H42" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.0003 36.75H11.667" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M42 32.6667V25.6667C42 23.1 39.9 21 37.3333 21H18.6667C16.1 21 14 23.1 14 25.6667V32.6667" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M42 33.8333V36.75H33.8333C33.8333 39.97 31.22 42.5833 28 42.5833C24.78 42.5833 22.1667 39.97 22.1667 36.75H14V33.8333C14 31.2666 16.1 29.1666 18.6667 29.1666H37.3333C39.9 29.1666 42 31.2666 42 33.8333Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <h1>Sem documentos recentes.</h1>
                      <p>Quando houver serão mostrados aqui.</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path d="M14.9997 36.6668H24.9997C33.333 36.6668 36.6663 33.3335 36.6663 25.0002V15.0002C36.6663 6.66683 33.333 3.3335 24.9997 3.3335H14.9997C6.66634 3.3335 3.33301 6.66683 3.33301 15.0002V25.0002C3.33301 33.3335 6.66634 36.6668 14.9997 36.6668Z" stroke="#090909" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M26.25 15H13.75" stroke="#090909" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M26.25 25H13.75" stroke="#090909" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </section>
        </div>
        <div class="docs">
            <section v-if="documentModels.length">
                <div class="title">
                    <h1>Modelos de documento</h1>
                    <p>Sempre que precisar, visualize, baixe ou compartilhe um modelo de documento.</p>
                    <RouterLink :to="'/admin/help'">Ver mais</RouterLink>
                </div>
                <div class="button" @mousedown="scrollLeft('models')" v-if="leftPasserModels">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="button inative" v-else></div>
                <div class="itens" ref="contentModelsRef" @mousedown="startDragging('models', $event)" @mousemove="dragging('models', $event)" @mouseup="stopDragging" @mouseleave="stopDragging">
                    <div class="item" v-for="model in documentModels">
                        <img v-if="model.file_mime_type == ModelFileMimeTypeEnum.PDF" src="@/assets/images/adobe.png" alt="Imagem do tipo de arquivo do documento.">
                        <img v-else-if="model.file_mime_type == ModelFileMimeTypeEnum.WORD" src="@/assets/images/word.png" alt="Imagem do tipo de arquivo do documento.">
                        <div class="infos">
                            <h1>{{ model.name }}</h1>
                            <h2>{{ model.description }}</h2>
                            <div>
                                <button class="download" @click="downloadFiles(model.files as ModelFileInterface[])">
                                    <p>baixar</p>
                                    <figure>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                          <path stroke="none" fill-rule="evenodd" clip-rule="evenodd" d="M9.99984 1.4C10.159 1.4 10.3116 1.46321 10.4241 1.57574C10.5366 1.68826 10.5998 1.84087 10.5998 2V11.2187L13.5758 8.24267C13.6308 8.18372 13.697 8.13644 13.7706 8.10364C13.8442 8.07085 13.9237 8.05321 14.0042 8.05179C14.0848 8.05037 14.1648 8.06519 14.2395 8.09537C14.3142 8.12555 14.3821 8.17046 14.4391 8.22744C14.496 8.28441 14.541 8.35228 14.5711 8.42699C14.6013 8.5017 14.6161 8.58172 14.6147 8.66228C14.6133 8.74285 14.5957 8.8223 14.5629 8.8959C14.5301 8.9695 14.4828 9.03574 14.4238 9.09067L10.4238 13.0907C10.3113 13.203 10.1588 13.2661 9.99984 13.2661C9.84084 13.2661 9.68834 13.203 9.57584 13.0907L5.57584 9.09067C5.51689 9.03574 5.46961 8.9695 5.43682 8.8959C5.40402 8.8223 5.38639 8.74285 5.38497 8.66228C5.38355 8.58172 5.39837 8.5017 5.42854 8.42699C5.45872 8.35228 5.50363 8.28441 5.56061 8.22744C5.61758 8.17046 5.68545 8.12555 5.76016 8.09537C5.83487 8.06519 5.9149 8.05037 5.99546 8.05179C6.07602 8.05321 6.15547 8.07085 6.22907 8.10364C6.30267 8.13644 6.36891 8.18372 6.42384 8.24267L9.39984 11.2187V2C9.39984 1.84087 9.46305 1.68826 9.57558 1.57574C9.6881 1.46321 9.84071 1.4 9.99984 1.4ZM3.33317 13.3333C3.50998 13.3333 3.67955 13.4036 3.80458 13.5286C3.9296 13.6536 3.99984 13.8232 3.99984 14V16C3.99984 16.7387 4.59451 17.3333 5.32784 17.3333H14.6678C14.8429 17.3333 15.0162 17.2988 15.1779 17.2318C15.3396 17.1648 15.4865 17.0666 15.6102 16.9427C15.7339 16.8189 15.832 16.6719 15.8988 16.5101C15.9657 16.3484 16 16.175 15.9998 16V14C15.9998 13.8232 16.0701 13.6536 16.1951 13.5286C16.3201 13.4036 16.4897 13.3333 16.6665 13.3333C16.8433 13.3333 17.0129 13.4036 17.1379 13.5286C17.2629 13.6536 17.3332 13.8232 17.3332 14V16C17.3332 16.707 17.0524 17.3851 16.5526 17.8851C16.0528 18.3852 15.3749 18.6663 14.6678 18.6667H5.32784C4.97795 18.6665 4.63152 18.5974 4.30837 18.4632C3.98521 18.3291 3.69166 18.1326 3.4445 17.8849C3.19733 17.6372 3.00141 17.3433 2.86791 17.0199C2.73442 16.6965 2.66598 16.3499 2.66651 16V14C2.66651 13.8232 2.73674 13.6536 2.86177 13.5286C2.98679 13.4036 3.15636 13.3333 3.33317 13.3333Z"/>
                                        </svg>
                                    </figure>
                                </button>
                                <button v-if="model.file_mime_type !== ModelFileMimeTypeEnum.WORD" class="tooltip view" @click="selectedModel = model; isModelModalOpen = true">
                                    <figure>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path fill="none" d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path fill="none" d="M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </figure>
                                </button>
                                <!-- <button class="tooltip">
                                    <figure>
                                        <svg stroke="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path stroke="none" d="M13.1202 17.0232L8.92121 14.7332C8.373 15.3193 7.66119 15.7269 6.87828 15.9031C6.09537 16.0793 5.27756 16.0159 4.53113 15.7212C3.7847 15.4266 3.14417 14.9142 2.69277 14.2507C2.24138 13.5871 2 12.8032 2 12.0007C2 11.1982 2.24138 10.4143 2.69277 9.75076C3.14417 9.08725 3.7847 8.57486 4.53113 8.28017C5.27756 7.98548 6.09537 7.92212 6.87828 8.09832C7.66119 8.27452 8.373 8.68214 8.92121 9.26821L13.1212 6.97821C12.8831 6.03417 12.9975 5.0357 13.4429 4.16997C13.8884 3.30424 14.6342 2.63069 15.5408 2.27557C16.4473 1.92046 17.4522 1.90816 18.3671 2.24098C19.2821 2.57381 20.0442 3.2289 20.5107 4.08347C20.9772 4.93804 21.116 5.93341 20.9011 6.88299C20.6862 7.83257 20.1323 8.67116 19.3433 9.24158C18.5543 9.81199 17.5843 10.0751 16.6152 9.98148C15.6462 9.88789 14.7445 9.44407 14.0792 8.73321L9.87921 11.0232C10.0404 11.6646 10.0404 12.3358 9.87921 12.9772L14.0792 15.2672C14.7448 14.5567 15.6467 14.1133 16.6158 14.0202C17.5849 13.9271 18.5547 14.1906 19.3434 14.7614C20.1322 15.3322 20.6856 16.171 20.9001 17.1207C21.1146 18.0703 20.9754 19.0656 20.5085 19.9199C20.0417 20.7743 19.2793 21.429 18.3642 21.7615C17.4491 22.0939 16.4442 22.0812 15.5379 21.7257C14.6315 21.3702 13.8859 20.6964 13.4408 19.8305C12.9958 18.9646 12.8818 17.9661 13.1202 17.0222M6.00021 14.0002C6.53064 14.0002 7.03935 13.7895 7.41442 13.4144C7.78949 13.0393 8.00021 12.5306 8.00021 12.0002C8.00021 11.4698 7.78949 10.9611 7.41442 10.586C7.03935 10.2109 6.53064 10.0002 6.00021 10.0002C5.46977 10.0002 4.96107 10.2109 4.58599 10.586C4.21092 10.9611 4.00021 11.4698 4.00021 12.0002C4.00021 12.5306 4.21092 13.0393 4.58599 13.4144C4.96107 13.7895 5.46977 14.0002 6.00021 14.0002ZM17.0002 8.00021C17.5306 8.00021 18.0393 7.78949 18.4144 7.41442C18.7895 7.03935 19.0002 6.53064 19.0002 6.00021C19.0002 5.46977 18.7895 4.96107 18.4144 4.58599C18.0393 4.21092 17.5306 4.00021 17.0002 4.00021C16.4698 4.00021 15.9611 4.21092 15.586 4.58599C15.2109 4.96107 15.0002 5.46977 15.0002 6.00021C15.0002 6.53064 15.2109 7.03935 15.586 7.41442C15.9611 7.78949 16.4698 8.00021 17.0002 8.00021ZM17.0002 20.0002C17.5306 20.0002 18.0393 19.7895 18.4144 19.4144C18.7895 19.0393 19.0002 18.5306 19.0002 18.0002C19.0002 17.4698 18.7895 16.9611 18.4144 16.586C18.0393 16.2109 17.5306 16.0002 17.0002 16.0002C16.4698 16.0002 15.9611 16.2109 15.586 16.586C15.2109 16.9611 15.0002 17.4698 15.0002 18.0002C15.0002 18.5306 15.2109 19.0393 15.586 19.4144C15.9611 19.7895 16.4698 20.0002 17.0002 20.0002Z"/>
                                        </svg>
                                    </figure>
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button" @mousedown="scrollRight('models')" v-if="rigthPasserModels">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </section>
            <div v-else class="else">
              <h1>Modelos de documento</h1>
              <h2>Nesse espaço estarão todos os modelos de documentos necessários para que você possa desempenhar o seu melhor trabalho. Modelos de oficios, solicitações, requerimentos e outros.</h2>
            </div>
            <hr>
            <section v-if="documentFlowModels.length">
                <div class="title">
                    <h1>Fluxo de documentos</h1>
                    <p>Sempre que precisar, visualize, baixe ou compartilhe um fluxo de processo de documento.</p>
                    <RouterLink :to="'/admin/help'">Ver mais</RouterLink>
                </div>
                <div class="button" @mousedown="scrollLeft('fluxo')" v-if="leftPasserFluxo">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="button inative" v-else></div>
                <div class="itens" ref="contentFluxoRef" @mousedown="startDragging('fluxo', $event)" @mousemove="dragging('fluxo', $event)" @mouseup="stopDragging" @mouseleave="stopDragging">
                    <div class="item" v-for="model in documentFlowModels">
                        <img v-if="model.file_mime_type == ModelFileMimeTypeEnum.PDF" src="@/assets/images/adobe.png" alt="Imagem pdf.">
                        <img v-else-if="model.file_mime_type == ModelFileMimeTypeEnum.WORD" src="@/assets/images/word.png" alt="Imagem word.">
                        <div class="infos">
                            <h1>{{ model.name }}</h1>
                            <h2>{{ model.description }}</h2>
                            <div>
                                <button class="download" @click="downloadFiles(model.files as ModelFileInterface[])">
                                  <p>baixar</p>
                                  <figure>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                      <path stroke="none" fill-rule="evenodd" clip-rule="evenodd" d="M9.99984 1.4C10.159 1.4 10.3116 1.46321 10.4241 1.57574C10.5366 1.68826 10.5998 1.84087 10.5998 2V11.2187L13.5758 8.24267C13.6308 8.18372 13.697 8.13644 13.7706 8.10364C13.8442 8.07085 13.9237 8.05321 14.0042 8.05179C14.0848 8.05037 14.1648 8.06519 14.2395 8.09537C14.3142 8.12555 14.3821 8.17046 14.4391 8.22744C14.496 8.28441 14.541 8.35228 14.5711 8.42699C14.6013 8.5017 14.6161 8.58172 14.6147 8.66228C14.6133 8.74285 14.5957 8.8223 14.5629 8.8959C14.5301 8.9695 14.4828 9.03574 14.4238 9.09067L10.4238 13.0907C10.3113 13.203 10.1588 13.2661 9.99984 13.2661C9.84084 13.2661 9.68834 13.203 9.57584 13.0907L5.57584 9.09067C5.51689 9.03574 5.46961 8.9695 5.43682 8.8959C5.40402 8.8223 5.38639 8.74285 5.38497 8.66228C5.38355 8.58172 5.39837 8.5017 5.42854 8.42699C5.45872 8.35228 5.50363 8.28441 5.56061 8.22744C5.61758 8.17046 5.68545 8.12555 5.76016 8.09537C5.83487 8.06519 5.9149 8.05037 5.99546 8.05179C6.07602 8.05321 6.15547 8.07085 6.22907 8.10364C6.30267 8.13644 6.36891 8.18372 6.42384 8.24267L9.39984 11.2187V2C9.39984 1.84087 9.46305 1.68826 9.57558 1.57574C9.6881 1.46321 9.84071 1.4 9.99984 1.4ZM3.33317 13.3333C3.50998 13.3333 3.67955 13.4036 3.80458 13.5286C3.9296 13.6536 3.99984 13.8232 3.99984 14V16C3.99984 16.7387 4.59451 17.3333 5.32784 17.3333H14.6678C14.8429 17.3333 15.0162 17.2988 15.1779 17.2318C15.3396 17.1648 15.4865 17.0666 15.6102 16.9427C15.7339 16.8189 15.832 16.6719 15.8988 16.5101C15.9657 16.3484 16 16.175 15.9998 16V14C15.9998 13.8232 16.0701 13.6536 16.1951 13.5286C16.3201 13.4036 16.4897 13.3333 16.6665 13.3333C16.8433 13.3333 17.0129 13.4036 17.1379 13.5286C17.2629 13.6536 17.3332 13.8232 17.3332 14V16C17.3332 16.707 17.0524 17.3851 16.5526 17.8851C16.0528 18.3852 15.3749 18.6663 14.6678 18.6667H5.32784C4.97795 18.6665 4.63152 18.5974 4.30837 18.4632C3.98521 18.3291 3.69166 18.1326 3.4445 17.8849C3.19733 17.6372 3.00141 17.3433 2.86791 17.0199C2.73442 16.6965 2.66598 16.3499 2.66651 16V14C2.66651 13.8232 2.73674 13.6536 2.86177 13.5286C2.98679 13.4036 3.15636 13.3333 3.33317 13.3333Z"/>
                                    </svg>
                                  </figure>
                                </button>
                                <button v-if="model.file_mime_type !== ModelFileMimeTypeEnum.WORD" class="tooltip view" @click="selectedModel = model; isModelModalOpen = true">
                                    <figure>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill='none' d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill='none' d="M11.9998 20.2697C15.5298 20.2697 18.8198 18.1897 21.1098 14.5897C22.0098 13.1797 22.0098 10.8097 21.1098 9.39973C18.8198 5.79973 15.5298 3.71973 11.9998 3.71973C8.46984 3.71973 5.17984 5.79973 2.88984 9.39973C1.98984 10.8097 1.98984 13.1797 2.88984 14.5897C5.17984 18.1897 8.46984 20.2697 11.9998 20.2697Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    </figure>
                                </button>
                                <!-- <button class="tooltip">
                                    <figure>
                                        <svg stroke="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path stroke="none" d="M13.1202 17.0232L8.92121 14.7332C8.373 15.3193 7.66119 15.7269 6.87828 15.9031C6.09537 16.0793 5.27756 16.0159 4.53113 15.7212C3.7847 15.4266 3.14417 14.9142 2.69277 14.2507C2.24138 13.5871 2 12.8032 2 12.0007C2 11.1982 2.24138 10.4143 2.69277 9.75076C3.14417 9.08725 3.7847 8.57486 4.53113 8.28017C5.27756 7.98548 6.09537 7.92212 6.87828 8.09832C7.66119 8.27452 8.373 8.68214 8.92121 9.26821L13.1212 6.97821C12.8831 6.03417 12.9975 5.0357 13.4429 4.16997C13.8884 3.30424 14.6342 2.63069 15.5408 2.27557C16.4473 1.92046 17.4522 1.90816 18.3671 2.24098C19.2821 2.57381 20.0442 3.2289 20.5107 4.08347C20.9772 4.93804 21.116 5.93341 20.9011 6.88299C20.6862 7.83257 20.1323 8.67116 19.3433 9.24158C18.5543 9.81199 17.5843 10.0751 16.6152 9.98148C15.6462 9.88789 14.7445 9.44407 14.0792 8.73321L9.87921 11.0232C10.0404 11.6646 10.0404 12.3358 9.87921 12.9772L14.0792 15.2672C14.7448 14.5567 15.6467 14.1133 16.6158 14.0202C17.5849 13.9271 18.5547 14.1906 19.3434 14.7614C20.1322 15.3322 20.6856 16.171 20.9001 17.1207C21.1146 18.0703 20.9754 19.0656 20.5085 19.9199C20.0417 20.7743 19.2793 21.429 18.3642 21.7615C17.4491 22.0939 16.4442 22.0812 15.5379 21.7257C14.6315 21.3702 13.8859 20.6964 13.4408 19.8305C12.9958 18.9646 12.8818 17.9661 13.1202 17.0222M6.00021 14.0002C6.53064 14.0002 7.03935 13.7895 7.41442 13.4144C7.78949 13.0393 8.00021 12.5306 8.00021 12.0002C8.00021 11.4698 7.78949 10.9611 7.41442 10.586C7.03935 10.2109 6.53064 10.0002 6.00021 10.0002C5.46977 10.0002 4.96107 10.2109 4.58599 10.586C4.21092 10.9611 4.00021 11.4698 4.00021 12.0002C4.00021 12.5306 4.21092 13.0393 4.58599 13.4144C4.96107 13.7895 5.46977 14.0002 6.00021 14.0002ZM17.0002 8.00021C17.5306 8.00021 18.0393 7.78949 18.4144 7.41442C18.7895 7.03935 19.0002 6.53064 19.0002 6.00021C19.0002 5.46977 18.7895 4.96107 18.4144 4.58599C18.0393 4.21092 17.5306 4.00021 17.0002 4.00021C16.4698 4.00021 15.9611 4.21092 15.586 4.58599C15.2109 4.96107 15.0002 5.46977 15.0002 6.00021C15.0002 6.53064 15.2109 7.03935 15.586 7.41442C15.9611 7.78949 16.4698 8.00021 17.0002 8.00021ZM17.0002 20.0002C17.5306 20.0002 18.0393 19.7895 18.4144 19.4144C18.7895 19.0393 19.0002 18.5306 19.0002 18.0002C19.0002 17.4698 18.7895 16.9611 18.4144 16.586C18.0393 16.2109 17.5306 16.0002 17.0002 16.0002C16.4698 16.0002 15.9611 16.2109 15.586 16.586C15.2109 16.9611 15.0002 17.4698 15.0002 18.0002C15.0002 18.5306 15.2109 19.0393 15.586 19.4144C15.9611 19.7895 16.4698 20.0002 17.0002 20.0002Z"/>
                                        </svg>
                                    </figure>
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button" @mousedown="scrollRight('fluxo')"  v-if="rigthPasserFluxo">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </section>
            <div v-else class="else">
              <h1>Fluxo de documentos</h1>
              <h2>Nesse espaço estarão todos os fluxos de documentos necessários para que você possa desempenhar o seu melhor trabalho. Modelos de ofícios, solicitações, requerimentos e outros.</h2>
            </div>
        </div>
        <nav>
            <div class="tooltip" @click="$router.push('/admin/create-documents')">
                <figure>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 22.0001H3C2.59 22.0001 2.25 21.6601 2.25 21.2501C2.25 20.8401 2.59 20.5001 3 20.5001H21C21.41 20.5001 21.75 20.8401 21.75 21.2501C21.75 21.6601 21.41 22.0001 21 22.0001ZM19.02 3.48211C17.08 1.54211 15.18 1.49211 13.19 3.48211L11.98 4.69211C11.88 4.79211 11.84 4.95211 11.88 5.09211C12.2625 6.40449 12.9697 7.59923 13.9363 8.56583C14.9029 9.53242 16.0976 10.2397 17.41 10.6221C17.4809 10.6453 17.5568 10.6483 17.6293 10.6306C17.7017 10.6129 17.7678 10.5753 17.82 10.5221L19.02 9.31211C20.01 8.33211 20.49 7.38211 20.49 6.42211C20.5 5.43211 20.02 4.47211 19.02 3.48211ZM15.61 11.5301C15.32 11.3901 15.04 11.2501 14.77 11.0901C14.5507 10.9595 14.3371 10.8193 14.13 10.6701C13.96 10.5601 13.76 10.4001 13.57 10.2401C13.5088 10.1955 13.4519 10.1453 13.4 10.0901C13.07 9.81011 12.7 9.45011 12.37 9.05011C12.34 9.03011 12.29 8.96011 12.22 8.87011C12.12 8.75011 11.95 8.55011 11.8 8.32011C11.6575 8.13203 11.5272 7.93495 11.41 7.73011C11.25 7.46011 11.11 7.19011 10.97 6.91011C10.9492 6.86533 10.9288 6.82033 10.909 6.77511C10.761 6.44211 10.326 6.34511 10.069 6.60211L4.34 12.3311C4.21 12.4611 4.09 12.7111 4.06 12.8811L3.52 16.7111C3.42 17.3911 3.61 18.0311 4.03 18.4611C4.39 18.8111 4.89 19.0011 5.43 19.0011C5.55 19.0011 5.67 18.9911 5.79 18.9711L9.63 18.4311C9.81 18.4011 10.06 18.2811 10.18 18.1511L15.902 12.4301C16.162 12.1701 16.063 11.7251 15.726 11.5801C15.6873 11.5635 15.6486 11.5469 15.61 11.5301Z" fill="white"/>
                    </svg>
                </figure>
            </div>
        </nav>

        <MyModal :width="'400px'" :height="'481px'" :isOpen="isNotificationsModalOpen" :class="'notification'" :toggleModal="(v: boolean) => isNotificationsModalOpen = v" :zIndex="100">
            <h1>Notificações</h1>
            <div class="itens">
                <div class="item note" v-for="note in todayNotes" :key="note.id" @click="$router.push({ name: 'admin.notes.edit', params: { id: note.id } }); isNotificationsModalOpen = false">
                    <div class="note-label">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none">
                            <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.6947 13.7H15.7037M15.6947 16.7H15.7037M11.9955 13.7H12.0045M11.9955 16.7H12.0045M8.29431 13.7H8.30329M8.29431 16.7H8.30329" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>Lembrete de hoje</span>
                    </div>
                    <h1>{{ note.title }}</h1>
                    <h2 v-if="note.description" v-html="note.description"></h2>
                    <h2 class="note-date">{{ note.event_date.split('-').reverse().join('/') }}</h2>
                </div>
                <div class="item black" v-for="document in recentDocuments" :key="document.id">
                    <h2>{{ new Date(document.created_at).toLocaleDateString() }}</h2>
                    <h2>Ofício <strong>Nº {{ document.number }}</strong></h2>
                    <h1>{{ document.title }}</h1>
                    <h2>{{ document.creator.organization?.acronym  ?? 'Sem organização' }}</h2>
                </div>
                <div class="empty-notifications" v-if="!todayNotes.length && !recentDocuments?.length">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <path d="M12.5206 3.41016C9.21058 3.41016 6.52058 6.10016 6.52058 9.41016V12.3002C6.52058 12.9102 6.26058 13.8402 5.95058 14.3602L4.80058 16.2702C4.09058 17.4502 4.58058 18.7602 5.88058 19.2002C10.1906 20.6402 14.8406 20.6402 19.1506 19.2002C20.3606 18.8002 20.8906 17.3702 20.2306 16.2702L19.0806 14.3602C18.7806 13.8402 18.5206 12.9102 18.5206 12.3002V9.41016C18.5206 6.11016 15.8206 3.41016 12.5206 3.41016Z" stroke="#D3D3D3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M14.3699 3.69994C14.0599 3.60994 13.7399 3.53994 13.4099 3.49994C12.4499 3.37994 11.5299 3.44994 10.6699 3.69994C10.9599 2.95994 11.6799 2.43994 12.5199 2.43994C13.3599 2.43994 14.0799 2.95994 14.3699 3.69994Z" stroke="#D3D3D3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.5195 19.5601C15.5195 21.2101 14.1695 22.5601 12.5195 22.5601C11.6995 22.5601 10.9395 22.2201 10.3995 21.6801C9.85953 21.1401 9.51953 20.3801 9.51953 19.5601" stroke="#D3D3D3" stroke-width="1.5" stroke-miterlimit="10"/>
                    </svg>
                    <p>Sem notificações no momento</p>
                </div>
            </div>
        </MyModal>

        <MyModal v-if="selectedModel" :isOpen="isModelModalOpen" :class="'docView'" :toggleModal="(v: boolean) => isModelModalOpen = v" :width="'80rem'" :height="'50rem'" :zIndex='10'>
            <div v-if="selectedFilesSrc.length">
              <iframe v-for="src in selectedFilesSrc" :src="src" width="100%" height="100%"></iframe>
            </div>
            <SpinnerLoader v-else-if="selectedModel.files.length" />
            <p>{{ selectedModel?.description}}</p>
        </MyModal>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import { isNotificationsModalOpen, newNotification, viewNotification, checkLocalStorageNotification } from '@/global/states/ModalState'
import { storageUrl, user } from '@/global/states/GlobalState'
import { useAxios } from '@/api/axios'
import DocumentStatusEnum, { documentStatusTranslations, documentStatusDescriptions } from '@/enums/DocumentStatusEnum'
import ModelInterface, { ModelFileInterface } from '@/models/ModelInterface'
import ModelTypeEnum from '@/enums/ModelTypeEnum'
import ModelFileMimeTypeEnum from '@/enums/ModelFileMimeTypeEnum'
import { DocumentModel } from '@/models/DocumentModel'
import AlertModel from '@/models/AlertModel'
import NoteModel from '@/models/NoteModel'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'

/* api */
const axios = useAxios()
const documentStats = ref<{status: DocumentStatusEnum, count: number}[]>()
const models = ref<ModelInterface[]>()
const recentDocuments = ref<DocumentModel[]>()
const alert = ref<AlertModel>()
const todayNotes = ref<NoteModel[]>([])
const alertRemainingDays = computed(() => {
  if (!alert.value) return null

  const today = new Date()
  const todayDay = today.getDate()
  const limitDate = new Date(alert.value.limit_date)
  const limitDay = limitDate.getDate()

  let remainingDays = limitDay - todayDay
  if (remainingDays < 0) {
    remainingDays += new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()
  }

  let color = 'black'
  if (remainingDays <= 5) {
    color = 'red'
  } else if (remainingDays <= 10) {
    color = 'orange'
  }

  return { value: remainingDays, color }
})
const documentModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.DOCUMENT_MODEL))
const documentFlowModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.FLOW_MODEL))
const selectedModel = ref<ModelInterface>()
const isModelModalOpen = ref(false)
const selectedFilesSrc = ref<string[]>([])

async function loadSelectedModelFiles () {
  if (selectedModel.value?.files) {
    const sources = await Promise.all(
      selectedModel.value.files.map(async (file) => {
        return await visualizeFile(file as ModelFileInterface)
      })
    )
    selectedFilesSrc.value = sources
  }
}

async function visualizeFile (file: ModelFileInterface): Promise<string> {
  try {
    const response = await axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
    return URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

watch(selectedModel, async () => {
  await loadSelectedModelFiles()
}, { deep: true, immediate: true })

/* Input search ref v-model */
const searchInput = ref<string>('')

/* Defines whether the alert is visible or not. */
const isAlertVisible = ref<boolean>(true)

/* Note alert state */
const isNoteAlertVisible = ref<boolean>(true)
const noteAlertNote = computed(() => todayNotes.value[0] ?? null)
const noteAlertRemainingDays = computed(() => {
  if (!noteAlertNote.value) return null
  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
  const [year, month, day] = noteAlertNote.value.event_date.split('-').map(Number)
  const eventDate = new Date(year, month - 1, day)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const remainingDays = Math.round((eventDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))
  const isToday = remainingDays === 0
  let color = 'black'
  if (remainingDays <= 5) color = 'red'
  else if (remainingDays <= 10) color = 'orange'
  return { days: remainingDays, dayOfMonth: day, monthLabel: months[month - 1], color, isToday }
})

function stripHtml (html: string | null): string {
  if (!html) return ''
  return html.replace(/<[^>]*>/g, '').trim()
}

/* Variables passers */
const leftPasserModels = ref(false)
const rigthPasserModels = ref(true)
const leftPasserFluxo = ref(false)
const rigthPasserFluxo = ref(true)

/* Documents container ref. */
const contentModelsRef = ref<HTMLDivElement | null>(null)
const contentFluxoRef = ref<HTMLDivElement | null>(null)

/* Verify scroll */
const verifyScroll = () => {
  if (contentModelsRef.value) {
    leftPasserModels.value = !(contentModelsRef.value.scrollLeft == 0)
    rigthPasserModels.value = !(contentModelsRef.value.scrollLeft >= contentModelsRef.value.scrollWidth - contentModelsRef.value.clientWidth)
  }
  if (contentFluxoRef.value) {
    leftPasserFluxo.value = !(contentFluxoRef.value.scrollLeft == 0)
    rigthPasserFluxo.value = !(contentFluxoRef.value.scrollLeft >= contentFluxoRef.value.scrollWidth - contentFluxoRef.value.clientWidth)
  }
}

/* Document passer left. */
const scrollLeft = (content: string) => {
  if (content === 'models') {
    if (contentModelsRef.value) {
      contentModelsRef.value.scrollLeft -= 150
    }
  } else if (content === 'fluxo') {
    if (contentFluxoRef.value) {
      contentFluxoRef.value.scrollLeft -= 150
    }
  }
  verifyScroll()
}

/* Document passer right. */
const scrollRight = (content: string) => {
  if (content === 'models') {
    if (contentModelsRef.value) {
      contentModelsRef.value.scrollLeft += 150
      console.log(contentModelsRef.value.scrollLeft)
    }
  } else if (content === 'fluxo') {
    if (contentFluxoRef.value) {
      contentFluxoRef.value.scrollLeft += 150
      console.log(contentFluxoRef.value.scrollLeft)
    }
  }
  verifyScroll()
}

/* Container dragging method. */
let isDragging = false
let startX = 0
let scrollLeftDrag = 0

function startDragging (content: string, event: MouseEvent) {
  isDragging = true

  if (content === 'models') {
    startX = event.pageX - contentModelsRef.value!.offsetLeft
    scrollLeftDrag = contentModelsRef.value!.scrollLeft
  } else if (content === 'fluxo') {
    startX = event.pageX - contentFluxoRef.value!.offsetLeft
    scrollLeftDrag = contentFluxoRef.value!.scrollLeft
  }

  verifyScroll()
}

function dragging (content: string, event: MouseEvent) {
  if (!isDragging) return

  if (content === 'models') {
    const x = event.pageX - contentModelsRef.value!.offsetLeft
    const walk = (x - startX) * 0.8
          contentModelsRef.value!.scrollLeft = scrollLeftDrag - walk
  } else if (content === 'fluxo') {
    const x = event.pageX - contentFluxoRef.value!.offsetLeft
    const walk = (x - startX) * 0.8
          contentFluxoRef.value!.scrollLeft = scrollLeftDrag - walk
  }

  verifyScroll()
}

function stopDragging () {
  isDragging = false
  verifyScroll()
}

function getDashboardInfo () {
  axios.get('/api/dashboard/home')
    .then((res) => {
      alert.value = res.data.alert
      recentDocuments.value = res.data.documents
      models.value = res.data.models
      documentStats.value = res.data.stats
      todayNotes.value = res.data.todayNotes ?? []
      if (todayNotes.value.length > 0) {
        newNotification.value = true
      }
      verifyScroll()
    })
}

function downloadFiles (files: ModelFileInterface[]): void {
  files.forEach((file) => {
    axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
      .then(response => {
        const url = URL.createObjectURL(new Blob([response.data]))

        const link = window.document.createElement('a')
        link.href = url
        link.setAttribute('download', file.name)
        link.style.display = 'none'
        window.document.body.appendChild(link)
        link.click()
        window.document.body.removeChild(link)
      })
      .catch(error => {
        console.error('Erro ao buscar o documento:', error)
      })
  })
}

onMounted(() => {
  getDashboardInfo()
  checkLocalStorageNotification();
})
</script>

<style lang="scss">
    #home{
        width: 100%;
        max-width: 1200px;
        display: flex;
        flex-direction: column;
        padding-top: 30px;
        animation: enterContent ease .4s;
        header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            column-gap: 35px;
            margin: 0 0 50px 0;
            section{
                &:first-child{
                    width: 100%;
                    display: flex;
                    position: relative;
                    label{
                        width: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .indicative{
                          color: #FFF;
                          font-family: 'Inter', sans-serif;
                          font-size: 13px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: normal;
                          padding: 8px 23px;
                          background: $fluxoo-primary-color;
                          position: absolute;
                          top: calc(100% + 8px);
                          border-radius: 30px;
                          opacity: 0;
                          transition: opacity .2s;
                          &.visible{
                            opacity: 1;
                          }
                          &::before{
                            content: '';
                            width: 12px;
                            height: 12px;
                            position: absolute;
                            background: $fluxoo-primary-color;
                            margin: 0 auto;
                            top: -6px;
                            right: 0;
                            left: 0;
                            transform: rotate(45deg);
                          }
                        }
                        input{
                            width: 100%;
                            height: 55px;
                            border: none;
                            border-radius: 16px;
                            background: #F5F5F5;
                            color: $fluxoo-primary-color;
                            font-family: 'Inter', sans-serif;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: normal;
                            padding: 20px 56px 20px 20px;
                            box-sizing: border-box;
                            transition: background .2s;
                            &:focus{
                                border: unset !important;
                                outline: unset !important;
                                &::placeholder{
                                    color: transparent
                                }
                                & ~ svg{
                                    stroke: $fluxoo-primary-color;
                                }
                            }
                            &::placeholder{
                                color: #090909;
                                font-family: 'Inter', sans-serif;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: normal;
                            }
                            &:read-only{
                                cursor: default !important;
                            }
                            &.typed{
                              background: $fluxoo-menu-primary-color-hover !important;
                            }
                        }
                        svg{
                            width: 20px;
                            min-width: 20px;
                            height: 20px;
                            min-height: 20px;
                            position: absolute;
                            right: 20px;
                            stroke: #090909;
                            cursor: pointer;
                            &.typed{
                              stroke: $fluxoo-primary-color;
                            }
                        }
                    }
                }
                &:last-child{
                    display: flex;
                    align-items: center;
                    column-gap: 25px;
                    .infos{
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        h1{
                            color: #090909;
                            font-family: 'Inter', sans-serif;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: normal;
                            margin: 0;
                            white-space: nowrap;
                        }
                        h2{
                            color: #737373;
                            font-family: 'Inter', sans-serif;
                            font-size: 13px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                            margin: 0;
                        }
                    }
                    button{
                        width: 40px;
                        min-width: 40px;
                        height: 40px;
                        min-height: 40px;
                        border-radius: 50%;
                        background: transparent;
                        transition: background .2s;
                        cursor: pointer;
                        &:hover{
                            background: #F5F5F5;
                        }
                        figure{
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            svg{
                                width: 24px;
                                min-width: 24px;
                                height: 24px;
                                min-height: 24px;
                                stroke: #090909;
                            }
                        }
                    }
                    .profile{
                        width: 56px;
                        min-width: 56px;
                        height: 56px;
                        min-height: 56px;
                        border-radius: 50%;
                        background-position: center 0;
                        background-size: cover;
                        background-repeat: no-repeat;
                        cursor: pointer;
                        overflow: hidden;
                        img{
                          height: 100%;
                          width: 100%;
                          object-fit: cover;
                        }
                    }
                }
            }
        }
        .alert{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: start;
            border-radius: 24px;
            padding: 17px 20px;
            margin: 0 0 36px 0;
            box-sizing: border-box;
            column-gap: 24px;
            position: relative;
            figure{
                width: 58px;
                min-width: 58px;
                height: 58px;
                min-height: 58px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background: #FFF;
                margin: 0;
            }
            .days{
                height: 54px;
                display: flex;
                position: relative;
                margin: 0 18px 0 0;
                span{
                    color: #FFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                    margin: 0;
                    &:nth-child(1){
                        position: absolute;
                        top: -8px;
                        left: 4px;
                    }
                    &:nth-child(2){
                        position: absolute;
                        bottom: 7px;
                        right: -28px;
                        transform: rotate(90deg)
                    }
                }
                h1{
                    color: #FFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 54px;
                    font-style: normal;
                    font-weight: 800;
                    line-height: 73px;
                    margin: 0;
                }
            }
            .infos{
                display: flex;
                flex-direction: column;
                align-items: start;
                h1{
                    color: #FFF;
                    font-family: 'Nunito', sans-serif;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 800;
                    line-height: normal;
                    margin: 0;
                    text-align: start;
                }
                h2{
                    color: #FFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                    margin: 0;
                    text-align: start;
                }
            }
            button{
                width: 24px;
                height: 24px;
                position: absolute;
                top: 12px;
                right: 19px;
                figure{
                    width: 100%;
                    min-width: unset;
                    height: 100%;
                    min-height: unset;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: unset;
                    svg{
                        width: 24px;
                        min-width: 24px;
                        height: 24px;
                        min-height: 24px;
                        cursor: pointer;
                    }
                }
            }
            &.red{
                background: #A30711;
                figure{
                    svg{
                        fill: #A30711;
                    }
                }
            }
            &.orange{
                background: #E1793E;
                figure{
                    svg{
                        fill: #E1793E;
                    }
                }
            }
            &.black{
                background: #080808;
                figure{
                    svg{
                        fill: #080808;
                    }
                }
            }
        }
        .note-alert{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: start;
            border-radius: 24px;
            padding: 17px 20px;
            margin: 0 0 24px 0;
            box-sizing: border-box;
            column-gap: 24px;
            position: relative;
            animation: enterContent ease-in-out .4s;
            > figure{
                width: 58px;
                min-width: 58px;
                height: 58px;
                min-height: 58px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background: #FFF;
                margin: 0;
                flex-shrink: 0;
                svg{ fill: none; }
            }
            .days{
                height: 54px;
                display: flex;
                position: relative;
                margin: 0 18px 0 0;
                flex-shrink: 0;
                span{
                    color: #FFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                    margin: 0;
                    &:nth-child(1){
                        position: absolute;
                        top: -8px;
                        left: 4px;
                    }
                    &:nth-child(2){
                        position: absolute;
                        bottom: 7px;
                        right: -28px;
                        transform: rotate(90deg);
                    }
                }
                h1{
                    color: #FFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 54px;
                    font-style: normal;
                    font-weight: 800;
                    line-height: 73px;
                    margin: 0;
                }
            }
            .infos{
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: start;
                min-width: 0;
                h1{
                    color: #FFF;
                    font-family: 'Nunito', sans-serif;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 800;
                    line-height: normal;
                    margin: 0;
                    text-align: start;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
                h2{
                    color: rgba(255, 255, 255, 0.85);
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                    margin: 0;
                    text-align: start;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
            }
            .cta{
                flex-shrink: 0;
                padding: 10px 22px;
                border-radius: 30px;
                border: 1.5px solid rgba(255, 255, 255, 0.6);
                background: transparent;
                color: #FFF;
                font-family: 'Inter', sans-serif;
                font-size: 13px;
                font-weight: 700;
                letter-spacing: 0.5px;
                cursor: pointer;
                transition: background .2s, border-color .2s;
                white-space: nowrap;
                margin: 0 42px 0 0;
                &:hover{
                    background: rgba(255, 255, 255, 0.12);
                    border-color: #FFF;
                }
            }
            button.close{
                width: 24px;
                height: 24px;
                position: absolute;
                top: 12px;
                right: 19px;
                cursor: pointer;
                background: transparent;
                figure{
                    width: 100%;
                    min-width: unset;
                    height: 100%;
                    min-height: unset;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: unset;
                    svg{
                        width: 24px;
                        min-width: 24px;
                        height: 24px;
                        min-height: 24px;
                        cursor: pointer;
                    }
                }
            }
            &.red, &.orange, &.black{
                background: #5B35C8;
                > figure svg{ stroke: #5B35C8; }
            }
        }
        .updates{
            display: flex;
            align-items: end;
            column-gap: 20px;
            margin: 0 0 70px 0;
            section{
                display: flex;
                flex-direction: column;
                align-items: start;
                row-gap: 12px;
                &:first-child{
                    width: 100%;
                    max-width: 690px;
                    h1{
                        color: #090909;
                        font-family: 'Nunito', sans-serif;
                        font-size: 48px;
                        font-style: normal;
                        font-weight: 800;
                        line-height: normal;
                        margin: 0
                    }
                    .itens{
                        width: 100%;
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr;
                        column-gap: 13px;
                        row-gap: 14px;
                        .item{
                            width: 100%;
                            min-width: 180px;
                            height: 160px;
                            display: flex;
                            position: relative;
                            flex-direction: column;
                            align-items: start;
                            border-radius: 32px;
                            background: #E0ECE9;
                            transition: background .2s;
                            padding: 30px 20px;
                            box-sizing: border-box;
                            text-decoration: none;
                            cursor: pointer;
                            &.skeleton{
                                background-color: #E0ECE9 !important;
                                animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
                                h1, p, h2{
                                    color: #090909 !important;
                                }
                                &::after{
                                  border-color: #090909 !important;
                                }
                            }
                            h1{
                                color: #090909;
                                font-family: 'Inter', sans-serif;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 700;
                                line-height: normal;
                                margin: 0;
                                transition: color .2s;
                            }
                            p{
                                color: #090909;
                                font-family: 'Nunito', sans-serif;
                                font-size: 44px;
                                font-style: normal;
                                font-weight: 900;
                                line-height: normal;
                                margin: 2px 0 1px 0;
                                transition: color .2s;
                            }
                            h2{
                                width: 167px;
                                color: #090909;
                                font-family: 'Inter', sans-serif;
                                font-size: 13px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: normal;
                                margin: 0;
                                text-align: start;
                                transition: color .2s;
                            }
                            &::after{
                                content: '';
                                width: 10px;
                                height: 10px;
                                border-left: 2px solid #292D32;
                                border-top: 2px solid #292D32;
                                border-radius: 2px;
                                position: absolute;
                                top: 75px;
                                right: 27px;
                                transform: rotate(135deg);
                                transition: border-color .2s
                            }
                            &:hover{
                                background: $fluxoo-primary-color;
                                h1{
                                    color: #FFF;
                                }
                                p{
                                    color: #FFF;
                                }
                                h2{
                                    color: #FFF;
                                }
                                &::after{
                                    border-color: #FFF;
                                }
                            }
                            &.active{
                                background: $fluxoo-primary-color;
                                h1{
                                    color: #FFF;
                                }
                                p{
                                    color: #FFF;
                                }
                                h2{
                                    color: #FFF;
                                }
                                &::after{
                                    border-color: #FFF;
                                }
                            }
                        }
                    }
                }
                &:last-child{
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    width: 100%;
                    max-width: 488px;
                    h1{
                        height: 38px;
                        color: #FFF;
                        font-family: 'Nunito', sans-serif;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 800;
                        line-height: normal;
                        letter-spacing: 0.42px;
                        display: flex;
                        align-items: center;
                        padding: 0 24px;
                        margin: 0;
                        border-radius: 60px;
                        background: $fluxoo-primary-color;
                    }
                    .list{
                        width: 100%;
                        height: 334px;
                        display: flex;
                        border-radius: 30px;
                        background: $fluxoo-primary-color;
                        padding: 0 20px 0 20px;
                        box-sizing: border-box;
                        .itens{
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: start;
                            overflow-y: auto;
                            padding: 10px 0;
                            box-sizing: border-box;
                            justify-content: start;
                            &::-webkit-scrollbar{
                                width: 8px;
                                background: transparent
                            }
                            &::-webkit-scrollbar-thumb{
                                border-radius: 30px;
                                background: #FFF;
                            }
                            .item{
                                width: 100%;
                                display: flex;
                                align-items: center;
                                column-gap: 16px;
                                padding: 13px;
                                box-sizing: border-box;
                                border-radius: 24px;
                                cursor: pointer;
                                .name{
                                    width: 50px;
                                    min-width: 50px;
                                    height: 50px;
                                    min-height: 50px;
                                    border-radius: 50%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background: #FFF;
                                    transition: background .2s;
                                    h1{
                                        color: #000;
                                        text-align: center;
                                        font-family: 'Inter', sans-serif;
                                        font-size: 16px;
                                        font-style: normal;
                                        font-weight: 800;
                                        line-height: normal;
                                        padding: 0;
                                        background: unset;
                                        margin: 0;
                                        background: color .2s;
                                    }
                                }
                                .photo{
                                    width: 50px;
                                    min-width: 50px;
                                    height: 50px;
                                    min-height: 50px;
                                    border-radius: 50%;
                                    background-size: cover;
                                    background-repeat: no-repeat;
                                    background-position: center 0;
                                    h1{
                                        display: none;
                                    }
                                }
                                .infos{
                                    width: 100%;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: start;
                                    h1{
                                        width: 100%;
                                        height: unset;
                                        color: #FFF;
                                        font-family: 'Nunito', sans-serif;
                                        font-size: 16px;
                                        font-style: normal;
                                        font-weight: 700;
                                        line-height: normal;
                                        margin: 0;
                                        padding: 0;
                                        background: unset;
                                        border-radius: unset;
                                        text-align: start;
                                        transition: color .2s;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 1;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                    }
                                    h2{
                                        color: #FFF;
                                        font-family: 'Inter', sans-serif;
                                        font-size: 12px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: normal;
                                        margin: 0;
                                        transition: color .2s;
                                    }
                                }
                                &:hover{
                                    background: #FFF;
                                    .name{
                                        background: $fluxoo-primary-color;
                                        h1{
                                            color: #FFF;
                                        }
                                    }
                                    .infos{
                                        h1{
                                            color: $fluxoo-primary-color;
                                            text-decoration: underline;
                                        }
                                        h2{
                                            color: $fluxoo-primary-color;
                                        }
                                    }
                                }
                            }
                            &.empty{
                              display: flex;
                              flex-direction: column;
                              align-items: center;
                              justify-content: center;
                              svg{
                                display: flex;
                                width: 56px;
                                min-width: 56px;
                                height: 56px;
                                min-height: 56px;
                              }
                              h1{
                                letter-spacing: unset;
                                height: unset;
                                color: #FFF;
                                font-family: 'Inter', sans-serif;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 700;
                                line-height: normal;
                                margin: 12px 0 0 0;
                                padding: 0;
                                cursor: default;
                              }
                              p{
                                color: #FFF;
                                font-family: 'Inter', sans-serif;
                                font-size: 13px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                                margin: 4px 0 0 0;
                                cursor: default;
                              }
                            }
                        }
                    }
                    svg{
                        display: none;
                    }
                    &.noitens{
                        h1{
                            display: none;
                        }
                        .list{
                            background: #E0ECE9;
                            position: relative;
                            display: flex;
                            justify-content: center;
                            .itens{
                                display: none;
                            }
                            svg{
                                width: 40px;
                                min-width: 40px;
                                height: 40px;
                                min-height: 40px;
                                display: flex;
                                margin: 121px 0 0 0;
                            }
                            &::before{
                                content: 'Sem documentos novos';
                                color: #000;
                                font-family: 'Inter', sans-serif;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 700;
                                line-height: normal;
                                position: absolute;
                                top: 175px;
                            }
                            &::after{
                                content: 'Quando houver serão mostrados aqui.';
                                color: #090909;
                                font-family: 'Inter', sans-serif;
                                font-size: 13px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                                position: absolute;
                                top: 197px;
                            }
                        }
                    }
                }
            }
        }
        .docs{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 32px 0 32px 32px;
            border-radius: 40px;
            background: #F5F5F5;
            box-sizing: border-box;
            margin: 0 0 30px 0;
            section{
                width: 100%;
                display: flex;
                column-gap: 25px;
                position: relative;
                .title{
                    width: 170px;
                    min-width: 170px;
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                    row-gap: 16px;
                    h1{
                        color: #090909;
                        font-family: 'Nunito', sans-serif;
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 800;
                        line-height: 28px;
                        text-align: start;
                        margin: 0;
                    }
                    p{
                        color: #090909;
                        font-family: 'Nunito', sans-serif;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        text-align: start;
                        margin: 0;
                    }
                    a{
                      color: $fluxoo-primary-color;
                      font-family: 'Nunito', sans-serif;
                      font-size: 15px;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      text-align: start;
                      margin: 0;
                    }
                }
                .itens{
                    display: flex;
                    align-items: center;
                    column-gap: 20px;
                    padding: 0 20px 0 0;
                    overflow-x: auto;
                    cursor: grab;
                    &::-webkit-scrollbar{
                        height: 0;
                    }
                    .item{
                        width: 397px;
                        min-width: 397px;
                        height: 195px;
                        display: flex;
                        align-items: center;
                        column-gap: 22px;
                        border-radius: 28px;
                        background: #FFF;
                        padding: 30px 20px;
                        box-sizing: border-box;
                        user-select: none;
                        img{
                            width: 85px;
                            min-width: 85px;
                            height: 85px;
                            min-height: 85px;
                            user-select: none;
                            pointer-events: none;
                        }
                        .infos{
                            h1{
                                min-height: 54px;
                                color: #090909;
                                font-family: 'Nunito', sans-serif;
                                font-size: 20px;
                                font-style: normal;
                                font-weight: 800;
                                line-height: normal;
                                text-align: start;
                                margin: 0;
                                user-select: none;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            h2{
                                min-height: 34px;
                                color: #6F6F6F;
                                font-family: 'Inter', sans-serif;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                                margin: 4px 0 12px 0;
                                text-align: start;
                                user-select: none;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            div{
                                display: flex;
                                align-items: center;
                                justify-content: start;
                                column-gap: 50px;
                                button{
                                    width: 24px;
                                    min-width: 24px;
                                    height: 24px;
                                    min-height: 24px;
                                    cursor: pointer;
                                    &.tooltip{
                                        &.view{
                                          &::before{
                                              content: 'Visualizar';
                                              width: 83px;
                                          }
                                        }
                                        &.download{
                                            &::before{
                                                content: 'Baixar';
                                                width: 63px;
                                            }
                                        }
                                        &:nth-child(3){
                                            &::before{
                                                content: 'Compartilhar';
                                                width: 102px;
                                            }
                                        }
                                    }
                                    &.download{
                                      width: 143px;
                                      min-width: 143px;
                                      height: 45px;
                                      min-height: 45px;
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                      column-gap: 10px;
                                      border-radius: 50px;
                                      background: #FFF;
                                      box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.15);
                                      transition: background .2s;
                                      figure{
                                        width: 20px;
                                        svg{
                                          width: 20px;
                                          min-width: 20px;
                                          height: 20px;
                                          min-height: 20px;
                                        }
                                      }
                                      p{
                                        color: #000;
                                        font-family: 'Inter', sans-serif;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: normal;
                                        margin: 0;
                                        transition: color .2s;
                                      }
                                      &:hover{
                                        background: $fluxoo-primary-color;
                                        p{
                                          color: #fff;
                                        }
                                        figure{
                                          svg{
                                            fill: #fff;
                                          }
                                        }
                                      }
                                    }
                                    figure{
                                        width: 100%;
                                        height: 100%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        margin: 0;
                                        svg{
                                            width: 24px;
                                            min-width: 24px;
                                            height: 24px;
                                            min-height: 24px;
                                            stroke: #080808;
                                            fill: #080808;
                                            transition: all .2s
                                        }
                                        &:hover{
                                            svg{
                                                stroke: $fluxoo-primary-color;
                                                fill: $fluxoo-primary-color;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .button{
                    width: 50px;
                    min-width: 50px;
                    height: 50px;
                    min-height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #FFF;
                    border-radius: 50%;
                    margin: auto 0;
                    transition: background .2s;
                    animation: enterContent ease .2s;
                    cursor: pointer;
                    filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.12));
                    &.inative{
                      background: transparent !important;
                      cursor: default !important;
                    }
                    svg{
                      width: 24px;
                      min-width: 24px;
                      height: 24px;
                      min-height: 24px;
                      stroke: #090909;
                      transition: stroke .2s;
                    }
                    &:nth-child(2){
                      position: absolute;
                      top: 68px;
                      left: 203px;
                      rotate: 180deg;
                    }
                    &:nth-child(4){
                      position: absolute;
                      top: 68px;
                      right: 8px;
                    }
                    &:hover{
                        background: $fluxoo-primary-color;
                        svg{
                            stroke: #FFF;
                        }
                    }
                }
            }
            .else{
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 0 32px 0 0;
              h1{
                color: #090909;
                font-family: 'Nunito', sans-serif;
                text-align: center;
                font-size: 28px;
                font-style: normal;
                font-weight: 800;
                line-height: 28px;
                margin: 30px 0 13px 0;
              }
              h2{
                max-width: 600px;
                color: #090909;
                font-family: 'Nunito', sans-serif;
                text-align: center;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin: 0;
              }
              &:last-child{
                h1{
                  margin: 0 0 13px 0;
                }
                h2{
                  margin: 0 0 30px 0;
                }
              }
            }
            hr{
                width: 100%;
                height: 1px;
                background: #D3D3D3;
                border: none;
                margin: 50px 32px 50px 0;
            }
        }
        nav{
            width: 60px;
            min-width: 60px;
            height: 60px;
            min-height: 60px;
            background: $fluxoo-primary-color;
            border-radius: 50%;
            position: fixed;
            right: 20px;
            bottom: 20px;
            transition: background .2s;
            filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.35));
            cursor: pointer;
            div{
                &::before{
                    width: 93px;
                    left: -18px;
                    content: 'Criar novo documento';
                }
                figure{
                    width: 100%;
                    height: 100%;
                    margin: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    svg{
                        width: 20px;
                        min-width: 20px;
                        height: 20px;
                        min-height: 20px;
                    }
                }
            }
            &:hover{
                background: $fluxoo-primary-color-hover;
            }
        }
        .modal{
            &__content{
                padding: 32px 26px;
                h1{
                    color: #292F31;
                    font-family: 'Nunito', sans-serif;
                    font-size: 24px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    margin: 0 auto 40px 0;
                    text-align: start;
                }
                button{
                    display: flex;
                }
                .itens{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    row-gap: 10px;
                    overflow-y: auto;
                    padding: 0 12px 0 0;
                    .item{
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        border-radius: 24px;
                        padding: 16px 24px;
                        box-sizing: border-box;
                        cursor: pointer;
                        h1{
                            color: #FFF;
                            font-family: 'Nunito', sans-serif;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: normal;
                            text-transform: uppercase;
                            margin: 0;
                        }
                        h2{
                            color: #FFF;
                            font-family: 'Inter', sans-serif;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                            margin: 0;
                            &:last-child{
                                margin: 0 0 3px 0;
                            }
                        }
                        &.red{
                            background: #A30711;
                        }
                        &.orange{
                            background: #E1793E;
                        }
                        &.black{
                            background: #090909;
                        }
                        &.note{
                            background: $fluxoo-primary-color;
                            transition: background .2s;
                            &:hover{
                                background: $fluxoo-primary-color-hover;
                            }
                            .note-label{
                                display: flex;
                                align-items: center;
                                column-gap: 5px;
                                background: rgba(255, 255, 255, 0.18);
                                border-radius: 30px;
                                padding: 4px 10px 4px 8px;
                                margin: 0 0 8px 0;
                                span{
                                    color: #FFF;
                                    font-family: 'Inter', sans-serif;
                                    font-size: 10px;
                                    font-weight: 700;
                                    letter-spacing: 0.5px;
                                    text-transform: uppercase;
                                }
                            }
                            h2{
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                &.note-date{
                                    opacity: 0.7;
                                    font-size: 12px;
                                    margin: 4px 0 0 0;
                                    -webkit-line-clamp: 1;
                                }
                            }
                        }
                        &:last-child{
                          margin: 0 0 20px 0;
                        }
                    }
                    .empty-notifications{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 40px 20px;
                        row-gap: 10px;
                        p{
                            color: #D3D3D3;
                            font-family: 'Inter', sans-serif;
                            font-size: 14px;
                            font-weight: 500;
                            margin: 0;
                        }
                    }
                    &::-webkit-scrollbar{
                        width: 8px;
                        background: transparent;
                    }
                    &::-webkit-scrollbar-thumb{
                        border-radius: 30px;
                        background: #D3D3D3;
                    }
                }
            }
            &.docView{
              .modal__content{
                padding: 0;
              }
              div{
                height: 100%;
              }
              p{
                dispFlay: none;
              }
            }
            &.notification{
              .modal__content{
                border-radius: 16px !important;
                padding-bottom: unset !important;
              }
            }
        }
    }

    @media(max-width: 1250px){
        #home{
            .updates{
                section{
                    &:first-child{
                        .itens{
                            .item{
                                min-width: 200px;
                                h2{
                                    width: 167px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media(max-width: 1050px){
        #home{
            header{
                column-gap: 25px;
            }
            .updates{
                flex-direction: column;
                row-gap: 50px;
                section{
                    &:first-child{
                        width: 100%;
                        max-width: unset;
                        .itens{
                            .item{
                              min-width: 190px;
                              h2{
                                width: 167px !important;
                              }
                            }
                        }
                    }
                    &:last-child{
                        width: 100%;
                        max-width: unset;
                    }
                }
            }
        }
    }

    @media(max-width: 800px){
        #home{
            header{
                margin: 0 0 24px 0
            }
            .alert{
                height: unset;
                flex-direction: column;
                align-items: start;
                position: relative;
                row-gap: 13px;
                padding: 20px;
                .days{
                    margin: 0 0 0 82px;
                }
                figure{
                    position: absolute;
                }
                .infos{
                    row-gap: 8px;
                }
            }
            .note-alert{
                height: unset;
                flex-direction: column;
                align-items: start;
                row-gap: 13px;
                padding: 20px;
                > figure{
                    position: absolute;
                }
                .days{
                    margin: 0 0 0 82px;
                }
                .infos{
                    width: 100%;
                    row-gap: 8px;
                }
                .cta{
                    margin: 0;
                }
            }
            .updates{
                section{
                    &:first-child{
                        .itens{
                            .item{
                                h2{
                                    width: 167px !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media(max-width: 768px){
        #home{
            padding-top: 20px;
            header{
                flex-direction: column;
                row-gap: 20px;
                section{
                    &:first-child{
                        order: 2;
                    }
                    &:last-child{
                        width: 100%;
                        justify-content: space-between;
                        order: 1;
                        button{
                            margin: 0 0 0 auto;
                        }
                    }
                }
            }
            .updates{
                section{
                    &:first-child{
                        .itens{
                            .item{
                                h2{
                                    width: 125px;
                                }
                            }
                        }
                    }
                }
            }
            .docs{
                section{
                    .button{
                        display: none;
                    }
                }
            }
        }
    }

    @media(max-width: 740px){
        #home{
            header{
                flex-direction: column;
                row-gap: 20px;
                section{
                    &:first-child{
                        order: 2;
                    }
                    &:last-child{
                        order: 1;
                        margin: 0 0 0 auto
                    }
                }
            }
            .updates{
                section{
                    &:first-child{
                        .itens{
                          grid-template-columns: 1fr 1fr;
                          grid-template-areas:
                          'top-l top-mid'
                          'top-r bottom-l'
                          'bottom-r bottom-r';
                        }
                    }
                }
            }
            .docs{
                height: unset;
                section{
                    flex-direction: column;
                    row-gap: 12px;
                    .title{
                        width: unset;
                        max-width: 80%;
                        margin: 0 0 12px 0;
                        row-gap: 10px;
                    }
                }
                hr{
                  margin: 40px 0 35px;
                }
            }
        }
    }

    @media(max-width: 520px){
        #home{
            .updates{
                section{
                    &:first-child{
                        .itens{
                            .item{
                                h2{
                                  width: 167px !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media(max-width: 500px){
        #home{
            padding-top: 25px;
            header{
                section{
                    &:last-child{
                        width: 100%;
                        justify-content: space-between;
                        .profile{
                            display: none;
                        }
                    }
                }
            }
            .alert{
                margin: 0 0 32px 0;
            }
            .updates{
                margin: 0 0 32px 0;
                section{
                    &:first-child{
                        h1{
                            font-size: 28px;
                        }
                        .itens{
                            .item{
                                height: 140px;
                                min-width: 138px;
                                padding: 22px 13px 24px;
                                justify-content: space-between;
                                p{
                                  font-size: 38px;
                                }
                                h2{
                                  width: 111px !important;
                                  font-size: 10px;
                                }
                                &:after{
                                  top: 63px;
                                  right: 23px;
                                }
                            }
                        }
                    }
                    &:last-child{
                        .list{
                            padding: 0 10px;
                            .itens{
                                .item{
                                    .infos{
                                        h1{
                                            line-height: 16px;
                                            margin: 0 0 3px 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .docs{
                padding: 25px 0 25px 17px;
                section{
                    .title{
                        max-width: 90%;
                        row-gap: 10px;
                        margin: 0 0 2px 0;
                        h1{
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 800;
                            line-height: 28px;
                        }
                    }
                    .itens{
                        .item{
                            width: 279px;
                            min-width: 279px;
                            height: 140px;
                            column-gap: 14px;
                            align-items: start;
                            padding: 20px 14px;
                            img{
                                width: 50px;
                                min-width: 50px;
                                height: 50px;
                                min-height: 50px;
                                margin: 4px 0 0 0;
                            }
                            .infos{
                                h1{
                                    min-height: 24px;
                                    font-size: 18px;
                                    -webkit-line-clamp: 1;
                                }
                                h2{
                                    min-height: 30px;
                                    font-size: 12px;
                                    margin: 4px 0 8px 0;
                                    -webkit-line-clamp: 2;
                                }
                                div{
                                  column-gap: 30px;
                                  button{
                                    &.download{
                                      width: 112px;
                                      min-width: 112px;
                                    }
                                  }
                                }
                            }
                        }
                    }
                }
                hr{
                    margin: 30px 0 21px;
                }
            }
        }
    }

    @media(max-width: 425px){
        #home{
          padding-bottom: 110px;
            header{
                section{
                    &:last-child{
                        display: none;
                    }
                }
            }
            nav{
                display: none;
            }
            .modal{
                &__content{
                    padding: 32px 15px;
                    padding-bottom: 0;
                    .itens{
                        height: unset;
                        box-sizing: border-box;
                        .item{
                            &:last-child{
                                margin: 0 0 12px 0;
                            }
                        }
                    }
                }
                &.notification{
                  .modal__content{
                    border-radius: 0 !important;
                  }
                }
            }
        }
    }

    @media(max-width: 360px){
        #home{
            .updates{
                section{
                    &:first-child{
                        .itens{
                            .item{
                                padding: 22px 13px 15px;
                                justify-content: space-between;
                                p{
                                    font-size: 31px;
                                }
                                &:after{
                                    top: 66px;
                                    right: 23px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
